import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import moment from 'moment';
import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createInboxMessage() {
  yield takeEvery(actions.CREATE_INBOX_MESSAGE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/inbox`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.CREATE_INBOX_MESSAGE_ENDED });
    }
  });
}

function* searchInboxMessages() {
  yield takeEvery(actions.SEARCH_INBOX_MESSAGES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/inbox?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.SEARCH_INBOX_MESSAGES_ENDED });
    }
  });
}

function* findInboxMessage() {
  yield takeEvery(actions.FIND_INBOX_MESSAGE, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/inbox/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.FIND_INBOX_MESSAGE_ENDED });
    }
  });
}

function* copyInboxMessage() {
  yield takeEvery(actions.COPY_INBOX_MESSAGE, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res_get = yield call([axios, 'get'], `${API_HOST}/api/inbox/${id}`);
      if (isFunction(onSuccess)) {
        delete res_get.data.data.image_path;
        res_get.data.data.type = res_get.data.data.inbox_message.type;
        res_get.data.data.show_in_inbox = res_get.data.data.inbox_message.show_in_inbox;
        res_get.data.data.need_push = res_get.data.data.inbox_message.need_push;
        res_get.data.data.push_title = res_get.data.data.inbox_message.push_title;
        res_get.data.data.push_content = res_get.data.data.inbox_message.push_content;
        res_get.data.data.member_list_id = res_get.data.data.inbox_message.member_list_id;
        res_get.data.data.push_starts_at = moment().add(1, 'hours').format('YYYY-MM-DD HH:mm');
        res_get.data.data.push_image_path = res_get.data.data.inbox_message.push_image_path;
        res_get.data.data.cms_type_code = 'Inbox';
        res_get.data.data.book_id = null;
        res_get.data.data.category_ids = [];

        const res_create = yield call([axios, 'post'], `${API_HOST}/api/inbox`, res_get.data.data);
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res_create.data);
        }
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.COPY_INBOX_MESSAGE_ENDED });
    }
  });
}

function* updateInboxMessage() {
  yield takeEvery(actions.UPDATE_INBOX_MESSAGE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${API_HOST}/api/inbox`,
        data,
        { timeout: 900000 }, // 15 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.UPDATE_INBOX_MESSAGE_ENDED });
    }
  });
}

function* deleteInboxMessages() {
  yield takeEvery(actions.DELETE_INBOX_MESSAGES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/inbox`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.DELETE_INBOX_MESSAGES_ENDED });
    }
  });
}

function* createInboxLineMessage() {
  yield takeEvery(actions.CREATE_INBOX_LINE_MESSAGE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/inbox/line`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox', 'createInboxLineMessage');
    } finally {
      yield put({ type: actions.CREATE_INBOX_LINE_MESSAGE_ENDED });
    }
  });
}

function* searchInboxLineMessages() {
  yield takeEvery(actions.SEARCH_INBOX_LINE_MESSAGES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/inbox/line?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.SEARCH_INBOX_LINE_MESSAGES_ENDED });
    }
  });
}

function* findInboxLineMessage() {
  yield takeEvery(actions.FIND_INBOX_LINE_MESSAGE, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/inbox/line/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.FIND_INBOX_LINE_MESSAGE_ENDED });
    }
  });
}

function* updateInboxLineMessage() {
  yield takeEvery(actions.UPDATE_INBOX_LINE_MESSAGE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${API_HOST}/api/inbox/line`,
        data,
        { timeout: 900000 }, // 15 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox', 'updateInboxLineMessage');
    } finally {
      yield put({ type: actions.UPDATE_INBOX_LINE_MESSAGE_ENDED });
    }
  });
}

function* archiveLineMessage() {
  yield takeEvery(actions.ARCHIVE_ALL_INBOX_LINE_MESSAGES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${API_HOST}/api/inbox/line/archiveInboxLineMessage`,
        data,
        { timeout: 900000 }, // 15 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox', 'archiveInboxLineMessage');
    } finally {
      yield put({ type: actions.ARCHIVE_ALL_INBOX_LINE_MESSAGES_ENDED });
    }
  });
}

function* deleteInboxLineMessages() {
  yield takeEvery(actions.DELETE_INBOX_LINE_MESSAGES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/inbox/line`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.DELETE_INBOX_LINE_MESSAGES_ENDED });
    }
  });
}

function* getLinePushedStatusMessages() {
  yield takeEvery(actions.GET_LINE_BATCH_PUSH_TASK_STATUS, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/inbox/line/${id}/status`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'inbox');
    } finally {
      yield put({ type: actions.GET_LINE_BATCH_PUSH_TASK_STATUS_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createInboxMessage),
    fork(searchInboxMessages),
    fork(findInboxMessage),
    fork(copyInboxMessage),
    fork(updateInboxMessage),
    fork(deleteInboxMessages),
    fork(getLinePushedStatusMessages),
    fork(createInboxLineMessage),
    fork(searchInboxLineMessages),
    fork(findInboxLineMessage),
    fork(updateInboxLineMessage),
    fork(archiveLineMessage),
    fork(deleteInboxLineMessages),
  ]);
}
